module.exports = __webpack_public_path__ + "static/joanna-kosinska-LAaSoL0LrYs-unsplash 2-754b3cf38487334262ed501153a6f381.png";